import { TOUR_TRANSLATIONS } from "../translations"

export const getSideComparisonSteps = (lang) => {
    const t = TOUR_TRANSLATIONS[lang]

    return [
        {
            target: '[data-tour="side-comparison-filters"]',
            title: t.sideComparisonFilters.title,
            content: t.sideComparisonFilters.content,
            disableBeacon: true,
        },
        {
            target: '[data-tour="side-comparison-table"]',
            title: t.sideComparisonTable.title,
            content: t.sideComparisonTable.content,
        },
    ]
}
